const WORKSPACE_KEYS = ['provider', 'patient', 'examId', 'patientdoe', 'patientId'];
const PATIENT_WORKSPACE_KEYS = ['patient', 'examId', 'patientdoe', 'patientId'];

export const getWorkspaceItem = key => localStorage.getItem(key);

export const getWorkspaceJSON = key => {
  const raw = getWorkspaceItem(key);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

export const setWorkspaceItem = (key, value) => {
  if (value === null || value === undefined || value === '') {
    localStorage.removeItem(key);
    return;
  }
  localStorage.setItem(key, value);
};

export const setWorkspaceJSON = (key, value) => {
  if (value === null || value === undefined) {
    localStorage.removeItem(key);
    return;
  }
  localStorage.setItem(key, JSON.stringify(value));
};

export const removeWorkspaceItem = key => {
  localStorage.removeItem(key);
};

/** One-time migration for users who still have data in sessionStorage. */
export const migrateWorkspaceFromSession = () => {
  WORKSPACE_KEYS.forEach(key => {
    if (localStorage.getItem(key) !== null) return;
    const fromSession = sessionStorage.getItem(key);
    if (fromSession !== null) {
      localStorage.setItem(key, fromSession);
      sessionStorage.removeItem(key);
    }
  });
};

export const clearWorkspaceStorage = () => {
  WORKSPACE_KEYS.forEach(removeWorkspaceItem);
};

export const clearPatientWorkspace = () => {
  PATIENT_WORKSPACE_KEYS.forEach(removeWorkspaceItem);
};

export function resolveProviderCode(explicitCode) {
  if (explicitCode) {
    return String(explicitCode).trim();
  }

  const provider = getWorkspaceJSON('provider');
  if (provider?.pcode) {
    return String(provider.pcode).trim();
  }

  const patient = getWorkspaceJSON('patient');
  if (patient?.pcode) {
    return String(patient.pcode).trim();
  }

  return '';
}
